/** Align with server Identity options: 12+, lowercase, uppercase, digit, non-alphanumeric. */
export const PASSWORD_POLICY_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;
